'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utils = require('../utils');

var index = utils.create({
  render: function render() {
    var _vm = this;

    var _h = _vm.$createElement;

    var _c = _vm._self._c || _h;

    return _c('div', {
      staticClass: "progress"
    }, [_c('div', {
      staticClass: "progress-bar",
      style: "width: ".concat(_vm.rate, "%")
    })]);
  },
  staticRenderFns: [],
  name: 'progress',
  props: {
    rate: {
      type: Number,
      default: 0
    }
  }
});

exports.default = index;
